import React, { Fragment } from 'react';

import {
  Modal,
  ModalContent,
  ModalContentBody,
  ModalContentFooter,
  ModalContentHeader,
  Text,
} from '@zapier/design-system';

import AsyncButton from 'app/developer-v3/components/AsyncButton';
import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';

type Props = {
  isSaving: boolean;
  onConfirm: () => void;
};

const TermsOnly = ({ isSaving, onConfirm }: Props) => {
  return (
    <Modal canClose={false} onClosed={() => undefined}>
      <ModalContent maxWidth="550px">
        <ModalContentHeader>
          Zapier Platform Agreement terms have changed
        </ModalContentHeader>
        <ModalContentBody>
          <Text tag="p" type="Body1">
            <Fragment>
              We recently updated the{' '}
              <Link href={`${PLATFORM_MARKETING_BASE_URL}/tos`} target="_blank">
                Zapier Platform Agreement
              </Link>{' '}
              terms. By continuing to use the Zapier Platform, you agree to
              these updated terms.
            </Fragment>
          </Text>
        </ModalContentBody>
        <ModalContentFooter>
          <AsyncButton
            disabled={isSaving}
            isWorking={isSaving}
            onClick={onConfirm}
          >
            Continue
          </AsyncButton>
        </ModalContentFooter>
      </ModalContent>
    </Modal>
  );
};

export default TermsOnly;
